class MapMeasureTool extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this._map = null;
    this._layers = [];
    this._unit = 'm²';
    this._observer = null;
    this._cleanupFns = [];
    console.log('==== MapMeasureTool: ');
    
    this.EVENT_IDS = {
      MAP_MEASURE_DIALOG_SHOW: 'map_measure_dialog_show', // 弹出地图测绘后触发
      MAP_MEASURE_DRAW_BUTTON_CLICK: 'map_measure_draw_button_click', // 点击开始绘制按钮触发
      MAP_MEASURE_DISCARD_BUTTON_CLICK: 'map_measure_discard_button_click', // 点击结束绘制按钮触发
      MAP_MEASURE_CLEAR_BUTTON_CLICK: 'map_measure_clear_button_click', // 点击清空按钮触发
      MAP_MEASURE_SWITCH_UNIT_BUTTON_CLICK: 'map_measure_switch_unit_button_click', // 点击切换单位按钮触发
      MAP_MEASURE_FINISH_MEASURE: 'map_measure_finish_measure', // 测绘成功后触发
      MAP_MEASURE_ADDRESS_SEARCH: 'map_measure_address_search', // 测绘地址搜索触发
      MAP_MEASURE_ADDRESS_SEARCH_RESULT_CLICK: 'map_measure_address_search_result_click', // 点击测绘地址搜索结果触发
    };
  }

  connectedCallback() {
    const title = this.getAttribute('data-title') || 'Map Measure';
    // 用 IntersectionObserver 延迟初始化第三方库/地图，只有当组件进入视口时才加载
    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this._initialized) {
            this._initialized = true;
            this._init().catch((err) => console.error('map init error', err));
            this._observer.disconnect();
          }
        });
      },
      {
        root: null,
        threshold: 0.05,
      }
    );
    this._observer.observe(this);
  }

  disconnectedCallback() {
    // 清理 map & listeners & 加载的脚本（若有）
    if (this._map && this._map.remove) {
      try {
        this._map.remove();
      } catch (e) {
        /* ignore */
      }
      this._map = null;
    }
    if (this._observer) {
      this._observer.disconnect();
    }
    // 释放绑定的 event / cleanup functions
    this._cleanupFns.forEach((fn) => {
      try {
        fn();
      } catch (e) {
        /* ignore */
      }
    });
    this._cleanupFns = [];
  }
  
  transformToStringList(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map((item) => {
      return JSON.stringify(item);
    });
  }

  async _getCurrentPosition() {
    // 优先使用浏览器 Geolocation API 获取位置, 否则使用 IP 位置服务
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve([position.coords.latitude, position.coords.longitude]);
          },
          (err) => {
            console.warn('Geolocation error:', err);
            // fallback to IP-based
            this._getIPLocation().then(resolve).catch(reject);
          },
          {
            timeout: 5000,
          }
        );
      } else {
        // fallback to IP-based
        this._getIPLocation().then(resolve).catch(reject);
      }
    });
  }

  async _getIPLocation() {
    // ipapi 方案
    // const response = await fetch('https://ipinfo.io/json');
    // const data = await response.json();
    // return [data.loc.split(',').map(Number)];
    
    async function getFromIpApi() {
      return await fetch('https://ipapi.co/json/')
        .then((response) => response.json())
        .then((data) => {
          return [data.latitude, data.longitude];
        });
    }

    // ipwho.com API 方案
    try {
      const response = await fetch('http://ipwho.is/');
      const data = await response.json();
      if (data.success || data.status === 'success') {
        return [data.latitude, data.longitude];
      } else {
        throw new Error('ipwho location lookup failed.');
      }
    } catch (error) {
      console.log('_getIPLocation error: ', error);
      
      // fallback to ipapi
      try {
        return await getFromIpApi();
      } catch (error) {
        console.error('getFromIpApi error: ', error);
      }
      throw error;
    }
  }

  _addMeasureToolEvent(measureTool) {
    const sectionId = this.dataset.sectionId;
    const wrapper = document.querySelector(`#shopify-section-${sectionId}`);
    if (!wrapper) {
      console.warn('MapMeasureTool: Section Wrapper not found');
      return;
    }
    console.log('wrapper: ', wrapper);
    const eventData = {
      page_info: {
        url: window.location.href,
        section: sectionId,
        module: 'MAP_MEASURE_AREA_DIALOG',
      },
      action: 'click',
    };
    let measurements;
    let _this = this;
    
    const buttons = wrapper.querySelectorAll('button[data-action]');
    buttons.forEach((btn) => {
      console.log('btn: ', btn);
      btn.addEventListener('click', function () {
        const action = this.getAttribute('data-action');
        measurements = measureTool.getMeasurements();

        switch (action) {
          case 'start-measure':
            console.log('开始测量');
            // 👉 在这里调用你开始测量的逻辑
            const shape = wrapper.querySelector('#shapeSelect').value;
            console.log('shape: ', shape);
            console.log('measureTool: ', measureTool);
            console.log('get measurements: ', measurements);
            measureTool.startDraw(shape);
            if (wrapper.querySelector('[data-action="stop-measure"]')) {
              wrapper.querySelector(
                '[data-action="stop-measure"]'
              ).disabled = false;
            }
            eventData.event_id = _this.EVENT_IDS.MAP_MEASURE_DRAW_BUTTON_CLICK;
            eventData.details = {
              measurements: _this.transformToStringList(measurements),
            };
            trackData(eventData);
            break;

          case 'stop-measure':
            console.log('停止测量');
            // 👉 调用停止逻辑
            measureTool.stopDraw();
            measurements = measureTool.getMeasurements();
            console.log('get measurements: ', measurements);
            eventData.event_id =
              _this.EVENT_IDS.MAP_MEASURE_DISCARD_BUTTON_CLICK;
            eventData.details = {
              measurements: _this.transformToStringList(measurements),
            };
            trackData(eventData);
            break;

          case 'clear-all':
            console.log('清除全部');
            // 👉 调用清除逻辑
            measureTool.stopDraw();
            measureTool.clearAll();
            
            measurements = measureTool.getMeasurements();
            console.log('get measurements: ', measurements);
            eventData.event_id = _this.EVENT_IDS.MAP_MEASURE_CLEAR_BUTTON_CLICK;
            eventData.details = {
              measurements: _this.transformToStringList(measurements),
            };
            trackData(eventData);
            break;

          case 'switch-unit':
            console.log('切换单位');
            // 👉 调用切换单位逻辑
            const currentUnit = measureTool.switchUnit();
            wrapper.querySelector('.unit-display').textContent =
              'Current Unit: ' + currentUnit;
              
              
            measurements = measureTool.getMeasurements();
            console.log('get measurements: ', measurements);
            eventData.event_id =
              _this.EVENT_IDS.MAP_MEASURE_SWITCH_UNIT_BUTTON_CLICK;
            eventData.details = {
              unit: currentUnit,
              measurements: _this.transformToStringList(measurements),
            };
            trackData(eventData);
            break;
          default:
            console.warn('未知动作:', action);
        }
      });
    });
  }

  debounce(fn, delay = 300) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  async _handleSearchInput(e, search) {
    const query = e.target.value;
    console.log('input query: ', query);
    console.log('input searchElement: ', search.searchElement.input.value);
    
    setTimeout(() => {
      console.log(`${query} input resultList: `, search.resultList.results);
      // 触发埋点
      const eventData = {
        page_info: {
          url: window.location.href,
          section: this.dataset.sectionId,
          module: 'MAP_MEASURE_AREA_DIALOG',
        },
        action: 'search',
        event_id: this.EVENT_IDS.MAP_MEASURE_ADDRESS_SEARCH,
        details: { query: query, search_results: this.transformToStringList(search.resultList.results), mapCenter: JSON.stringify(this._map.getCenter()), zoom: this._map._zoom },
      };
      trackData(eventData);
    }, 3000);
  }

  _addSearchListener(search) {
    const searchElm = this.querySelector(
      '.leaflet-control-geosearch form input'
    );
    console.log('searchElm: ', searchElm);
    searchElm.addEventListener(
      'input',
      this.debounce((e) => this._handleSearchInput(e, search), 300)
    );

    let _this = this;
    // 点击结果事件
    this._map.on('geosearch/showlocation', (e) => {
      console.log('geosearch/showlocation e: ', e);
      console.log('选中位置数据:', e.location);
      // 设置地图中心到选中位置
      this._map.setView([e.location.y, e.location.x], 15);
      setTimeout(() => {
        const eventData = {
          page_info: {
            url: window.location.href,
            section: _this.dataset.sectionId,
            module: 'MAP_MEASURE_AREA_DIALOG',
          },
          action: 'select',
          event_id: _this.EVENT_IDS.MAP_MEASURE_ADDRESS_SEARCH_RESULT_CLICK,
          details: {
            query: e.location.label,
            bounds: _this.transformToStringList(e.location.bounds),
            latitude: e.location.y,
            longitude: e.location.x,
            location: JSON.stringify(e.location),
            mapCenter: JSON.stringify(_this._map.getCenter()),
            zoom: _this._map._zoom,
          },
        };
        trackData(eventData);
      }, 2000);
    });
  }

  async _init() {
    // 1) 动态加载依赖：Leaflet CSS/JS, Geoman CSS/JS, Turf (for area calc)
    console.log('==== Start _loadAssetsJS: ');
    await Promise.all([this._loadAssetsJS(), this._loadAssetsCSS()]);

    // 2） 获取当前经纬度
    const coords = await this._getCurrentPosition();
    console.log('==== coords: ', coords);

    // 3) 初始化地图
    const L = window.L;
    if (!L) throw new Error('Leaflet not loaded');

    // create map inside shadowRoot container
    const mapContainer = this.querySelector('#map');
    const defaultZoom = 14;
    const defaultCoords = [43.6532, -79.3832]; // Toronto City

    const initialView = coords || defaultCoords;
    const initialZoom = coords ? 18 : defaultZoom; // 如果定位成功，放大一点

    this._map = L.map(mapContainer, {
      attributionControl: false,
    }).setView(initialView, initialZoom);

    // add tile layer (google satellite)
    L.tileLayer(
      '//www.google.com/maps/vt?lyrs=y@189&gl=us&hl=en&x={x}&y={y}&z={z}',
      {
        maxZoom: 20,
        minZoom: 3,
        attribution: 'Google.com',
      }
    ).addTo(this._map);

    // 4) 添加 Search 控件
    if (!window.GeoSearch) {
      console.warn('GeoSearch not found');
    }

    const customIcon = new L.Icon({
      iconUrl:
        'https://cdn.shopify.com/s/files/1/0744/3310/2122/files/map-location.png?v=1756187695', // 你的图标路径
      iconSize: [48, 48], // 图标大小 [width, height]
      iconAnchor: [24, 48], // 图标锚点（通常底部居中）
      popupAnchor: [0, -48], // Popup 弹出的位置偏移
    });

    let provider;
    if (window.innerWidth >= 1000) {
      provider = new GeoSearch.OpenStreetMapProvider({
        // 在这里添加 params 参数
        params: {
          'accept-language': 'en', // 强制返回英文结果
        },
      });
    } else {
      provider = new GeoSearch.GeoapifyProvider({
        // 在这里添加 params 参数
        params: {
          apiKey: '1e81d36da4d74d708a6cee4c177d038f',
          'accept-language': 'en', // 强制返回英文结果
        },
      });
    }

    // const search = new GeoSearch.GeoSearchControl({
    //   provider: new GeoSearch.OpenStreetMapProvider({
    //     // 在这里添加 params 参数
    //     params: {
    //       'accept-language': 'en', // 强制返回英文结果
    //     },
    //   }),
    //   marker: {
    //     icon: customIcon,
    //     draggable: false,
    //   },
    //   notFoundMessage: 'Sorry, that address could not be found.',
    //   style: 'bar',
    // });

    const search = new GeoSearch.GeoSearchControl({
      provider: provider,
      marker: {
        icon: customIcon,
        draggable: false,
      },
      notFoundMessage: 'Sorry, that address could not be found.',
      style: 'bar',
      zoomLevel: 13,
    });

    this._map.addControl(search);
    console.log('search: ', search);

    if (coords) {
      // 如果定位成功，添加标记
      L.marker(initialView, {
        icon: customIcon,
      })
        .addTo(this._map)
        .bindPopup('Your Location')
        .openPopup();
    }

    // 5) 初始化测量控件 MapMeasureTool
    const measureTool = new L.measureArea(this._map, {
      polygonOptions: {
        snappable: true,
        templineStyle: {
          color: '#3288FF',
        },
      },
    });
    measureTool.addStyles();

    console.log('=measureTool: ', measureTool);
    // 6) 添加测量按钮的事件监听
    this._addMeasureToolEvent(measureTool);

    // 7) 监听 Search 组件
    this._addSearchListener(search);

    // 8) 添加绘画事件完成后的回调
    this._map.on(
      'pm:create',
      () => {
        const measurements = measureTool.getMeasurements();
        const currentMeasurement = measurements[measurements.length - 1];
        console.log('measurements after pm:create: ', measurements);
        console.log('measurements after map', this._map);
        console.log('measurements after center', this._map.getCenter());
        const eventData = {
          page_info: {
            url: window.location.href,
            section: this.dataset.sectionId,
            module: 'MAP_MEASURE_AREA_DIALOG',
          },
          action: 'draw_complete',
          event_id: this.EVENT_IDS.MAP_MEASURE_FINISH_MEASURE,
          details: {
            currentMeasurement: JSON.stringify(currentMeasurement),
            measurements: this.transformToStringList(measurements),
            zoom: this._map._zoom,
            mapCenter: JSON.stringify(this._map.getCenter()),
          },
        };
        trackData(eventData);
      },
      this
    );

    // configure Geoman (drawing plugin)
    // if (!this._map.pm) {
    //   console.warn('geoman not found');
    // }
    // this._map.pm.addControls({
    //   position: 'topleft',
    //   drawMarker: false,
    //   drawPolyline: false,
    //   drawPolygon: false,
    //   drawRectangle: false,
    //   drawCircle: false,
    //   editMode: false,
    //   dragMode: false,
    //   cutPolygon: false,
    //   removalMode: false,
    // });

    // local state
    this._drawnLayers = [];

    // add to cleanup functions so disconnectCallback can remove listeners if needed
    this._cleanupFns.push(() => {
      try {
        this._map.off();
        this._map.remove();
      } catch (e) {
        /* ignore */
      }
    });
  }

  _clearAll() {
    if (!this._map) return;
    // remove only drawn layers (exclude base layers)
    const layersToRemove = [];
    this._map.eachLayer((layer) => {
      // Geoman creates layers with pm hooks; leaflets baselayer tiles are tile layers
      if (layer && layer.pm) layersToRemove.push(layer);
    });
    layersToRemove.forEach((l) => {
      try {
        this._map.removeLayer(l);
      } catch (e) {}
    });
    this._drawnLayers = [];
  }

  async _loadAssetsJS() {
    const sectionId = this.dataset.sectionId;
    const leafletSrc = this.dataset.assetLeaflet;
    const geomanSrc = this.dataset.assetGeoman;
    const drawSrc = this.dataset.assetDraw;
    const geosearchSrc = this.dataset.assetGeosearch;
    const measureSrc = this.dataset.assetMeasure;

    await Promise.all([
      this._loadScriptOnce(leafletSrc, 'assetLeaflet'),
      this._loadScriptOnce(geomanSrc, 'assetGeoman'),
      this._loadScriptOnce(drawSrc, 'assetDraw'),
      this._loadScriptOnce(geosearchSrc, 'assetGeosearch'),
      this._loadScriptOnce(measureSrc, 'assetMeasure'),
    ]);
  }

  // The map styles load with the map instead of render-blocking every page from the layout <head>.
  async _loadAssetsCSS() {
    const { assetLeafletCss, assetGeomanCss, assetGeosearchCss } = this.dataset;

    await Promise.all([assetLeafletCss, assetGeomanCss, assetGeosearchCss].filter(Boolean).map(this._loadStyleOnce));
  }

  _loadStyleOnce(href) {
    return new Promise((resolve) => {
      const existing = [...document.querySelectorAll('link[rel="stylesheet"]')].find((link) => link.href === href);
      if (existing) return resolve();

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      // A failed stylesheet should not stop the map from opening.
      link.onload = () => resolve();
      link.onerror = () => resolve();
      document.head.appendChild(link);
    });
  }

  _appendCssToShadow(url) {
    return new Promise((resolve, reject) => {
      try {
        // create link tag inside shadow root to scope CSS to shadow tree
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        // append to shadowRoot
        this.shadowRoot.appendChild(link);
        // small delay to allow stylesheet to be fetched (no cross-browser onload consistent)
        setTimeout(() => resolve(), 50);
      } catch (e) {
        reject(e);
      }
    });
  }

  _loadScriptOnce(src, id) {
    return new Promise((resolve, reject) => {
      // if script already loaded in window, resolve immediately
      if (id && document.getElementById(id)) {
        // small wait for library to be available
        return setTimeout(resolve, 10);
      }
      // If global object already present, resolve
      if (src.includes('leaflet.js') && window.L) {
        return resolve();
      }
      if (src.includes('geoman') && window.L && window.L.PM) {
        return resolve();
      }
      if (src.includes('draw') && window?.L?.measureArea) {
        return resolve();
      }
      if (src.includes('geosearch') && window?.GeoSearch) {
        return resolve();
      }

      const script = document.createElement('script');
      if (id) script.id = id;
      console.log('====src: ', src);
      script.src = src;
      script.async = false;
      // script.onload = () => setTimeout(resolve, 10);
      script.onload = () =>
        setTimeout(() => {
          console.log('====onload: ', src);
          resolve();
        }, 10);
      script.onerror = (e) => reject(new Error('Failed to load script ' + src));
      // append script to document head (not shadowRoot — scripts must run in main document)
      document.head.appendChild(script);
      // remember cleanup to remove script if disconnected (optional)
      this._cleanupFns.push(() => {
        try {
          document.head.removeChild(script);
        } catch (e) {}
      });
    });
  }
}

customElements.define('map-measure-tool', MapMeasureTool);
